export default __webpack_public_path__ + "img/32751daaa4c455753ffaf58ba922e31f.svg";